import { IResponse, ITag, ResponseCode } from "services/KnowfullyAdminClient";

// Mirrors the server's tag identity (compatibility-decomposed letters and digits, lower case) closely
// enough to skip a request for a tag the SKU already shows; the server still decides identity.
export const comparableName = (name: string) =>
  name.normalize("NFKD").replace(/[^\p{L}\p{N}]/gu, "").toLowerCase();

export const isOnSku = (name: string, skuTags: { tag?: Pick<ITag, "name"> }[]) => {
  const comparable = comparableName(name);
  return skuTags.some((skuTag) => comparableName(skuTag.tag?.name ?? "") === comparable);
};

export const optionName = (option: string | ITag) =>
  typeof option === "string" ? option : option.name ?? "";

// Query key of the tags a Tag Based Filter rule can select; adding or removing a SKU tag changes them.
export const skuRuleAvailableTagsKey = "skuRuleAvailableTags";

// The API reports a rejected tag as a 200 with a non-OK response code rather than an HTTP error.
export const responseError = (response: IResponse | null | undefined, fallback: string) =>
  response?.responseCode === ResponseCode.OK ? undefined : response?.responseReason || fallback;
